
    import Vue from "vue";
    import Component from "vue-class-component";
    import { StateChanger } from "vue-infinite-loading";
    import { Watch } from "vue-property-decorator";
    import * as toastr from "toastr";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import { appEventBus } from "@/utilities/EventBus";
    import SiteAddDialogue from "@/vue/components/SiteAddDialogue.vue";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import { SiteRegistrationType } from "@/model/Enums";
    import { SiteSearchParameters } from "@/model/SiteSearchParameters";
    import { ILookupItem } from "@/model/LookupItem";
    import { ISite, Site } from "@/model/Site";
    import { IClientLookup } from "@/model/Client";

    interface ISearchResponse {
        list: Array<ISite>;
        count: number;
    }

    @Component({
        components: { ApiButton, SiteAddDialogue }
    })
    export default class Sites extends Vue {

        async mounted(): Promise<void> {
            appEventBus.on("site-delete", this.onSiteDelete);
            await Promise.all([
                (async () => { this.clientList = await ApiClient.get("/api/client/lookups"); })(),
                (async () => { this.briefingList = await ApiClient.get(`/api/briefing/lookups?siteID=${Utils.emptyGuidValue}`); })()
            ]);
        }

        beforeDestroy() {
            appEventBus.off("site-delete", this.onSiteDelete);
        }

        //
        // -- properties
        //

        clientList: Array<IClientLookup> = [];
        get clientOptions(): Array<IClientLookup> { return Utils.clientOptionsFilter(this.clientList); }
        briefingList: Array<ILookupItem> = [];
        get registrationTypeList(): Array<ILookupItem> { return Utils.enumToLookups(SiteRegistrationType); }
        infiniteId: number = + new Date();
        searchParameters = new SiteSearchParameters();
        resultCount: string = "-";
        siteList: Array<ISite> = [];

        //
        // -- Watchers
        //

        debouncedRefreshSearch = Utils.debounce(this.refreshSearch, 200);

        @Watch("searchParameters.searchText")
        onSearchTextchanged(): void {
            this.debouncedRefreshSearch();
        }

        @Watch("searchParameters.clientID")
        private onClientIdchanged(): void {
            this.debouncedRefreshSearch();
        }

        //
        // -- methods
        //

        onSiteDelete(event: CustomEvent<any>) {
            const name = event.detail as string;
            toastr.info(name, "Deleted Site");
        }

        siteImageSource(site: Site): string {
            return site?.imageResource?.sourceUrl ?? require("@/images/missing.png");
        }

        // editNew(): void {
        //     this.$router.push({ name: "AdminSite", params: { siteID: Utils.emptyGuidValue } });
        // }

        showAddNewDialogue(): void {
            const dialog: SiteAddDialogue = this.$refs.siteAddDialogue as SiteAddDialogue;
            dialog.show();
        }

        onAddedSite(siteID: string): void {
            this.$router.push({ name: "AdminSite", params: { siteID: siteID } });
        }

        edit(site: ISite): void {
            this.$router.push({ name: "AdminSite", params: { siteID: site.id } });
        }

        refreshSearch(): void {
            this.resultCount = "-";
            this.siteList = [];
            this.searchParameters.pageNumber = 1;
            this.infiniteId += 1;
        }

        async infiniteLoadingHandler(stateChanger: StateChanger): Promise<void> {
            const response: ISearchResponse = await ApiClient.post("/Api/Site/Search", this.searchParameters);
            if(this.searchParameters.pageNumber === 1) {
                this.resultCount = String(response.count);
            }
            if (response.list.length) {
                //this.siteList.push(...mapData<Array<Site>>(response.list, { root: (s) => new Site (s) }));
                this.siteList.push(...response.list.map((s: ISite) => new Site(s)));
                this.searchParameters.pageNumber += 1;
                stateChanger.loaded();
            }
            else {
                stateChanger.complete();
            }
        }
    }
